"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getQuestionAncestors = void 0;
function getQuestionAncestors(db, q) {
    try {
        const parentList = db.lists[q.parentListId];
        return (parentList === null || parentList === void 0 ? void 0 : parentList.parentQId)
            ? [
                db.questions[parentList === null || parentList === void 0 ? void 0 : parentList.parentQId],
                ...getQuestionAncestors(db, db.questions[parentList === null || parentList === void 0 ? void 0 : parentList.parentQId]),
            ]
            : [];
    }
    catch (_a) {
        return [];
    }
}
exports.getQuestionAncestors = getQuestionAncestors;
